

document.querySelectorAll('.animator-popup__close').forEach((btn)=>{
	const popup = btn.closest('.animator-popup')
	btn.addEventListener('click',()=>{
		popup.classList.remove('_animate')
		setTimeout(()=>{
			popup.classList.remove('_display')
		},600)
	})
	
})
document.querySelectorAll('.afisha-card').forEach((item)=>{
	const popup =  document.querySelector('#animator-popup')
	const popupContent =  document.querySelector('#animator-popup-content')
	
	if(popup && popupContent){
		item.querySelector('.js-afisha-more')?.addEventListener('click',()=>{
			popupContent.innerHTML='';
			popupContent.append(item.cloneNode(true))
			popup.classList.add('_display')
			setTimeout(()=>{
				popup.classList.add('_animate')
			},100)

		})	
	}
})